export default "__VITE_PUBLIC_ASSET__010e51ab__"